import { createContext } from "react";

const Context = createContext();

export const ContextProvider = Context.Provider;
export default Context;
